import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import settings from "./modules/settings";
import signalr from "./modules/signalr";
import freshSeedBag from "./modules/fresh_seed_bag";
import createProgrammeSteps from "./modules/createProgrammeSteps";
import auth from "./modules/auth";
import custom_form from "./modules/custom_form";
import rule_conditions from "./modules/rule_conditions";
import barcode_conf from "./modules/barcode_conf";
import barcode_settings from "./modules/barcode_settings";
import info_sidebar from "./modules/info_sidebar";
import table_filter from "./modules/table_filter";
import custom_field_data from "./modules/custom_field_data";
import data_filter from "./modules/data_filter";
import current_user from "./modules/current_user";
import field_header from "./modules/field_header";
import recording_data from "./modules/recording_data";
import dashboard_layout from "./modules/dashboard_layout";
import personalize_dashboard from "./modules/personalize_dashboard";
import user_settings from "./modules/user_settings";
import public_thank_you_message from "./modules/public_thank_you_message";
import freshSeedTransaction from "./modules/fresh_seed_transaction";
import germinatedSeedTransaction from "./modules/germinated_seed_transaction";
import progeny from "./modules/progeny";
import country from "./modules/country";
import station from "./modules/station";
import material from "./modules/material";
import crossType from "./modules/cross_type";
import germplasm from "./modules/germplasm";
import matingDesign from "./modules/mating_design";
import germinatedSeedBag from "./modules/germinated_seed_bag";
import getters from "./getters";
import form_store from "./modules/form_store";
import species from "./modules/species";
import bunch from "./modules/bunch";
import general_filter from "./modules/general_filter";
import germinationBatch from "./modules/germination_batch";
import pollenBottleTransaction from "./modules/pollen_bottle_transaction";
import pollenBottle from "./modules/pollen_bottle";
import crossing_program from "./modules/crossing_program";
import fruit_type from "./modules/fruit_type";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        app,
        settings,
        auth,
        signalr,
        custom_form,
        rule_conditions,
        barcode_conf,
        barcode_settings,
        info_sidebar,
        table_filter,
        custom_field_data,
        data_filter,
        user,
        current_user,
        field_header,
        recording_data,
        dashboard_layout,
        personalize_dashboard,
        user_settings,
        public_thank_you_message,
        createProgrammeSteps,
        freshSeedTransaction,
        progeny,
        country,
        station,
        germinatedSeedTransaction,
        material,
        crossType,
        matingDesign,
        freshSeedBag,
        germplasm,
        form_store,
        species,
        germinatedSeedBag,
        bunch,
        general_filter,
        germinationBatch,
        pollenBottleTransaction,
        pollenBottle,
        crossing_program,
        fruit_type
    },
    state: {
        dialog: false,
        configurationInfo: {},

        SeriesForms: "",
        TraitsForm: [],
        BenchmarkForm: "",
        selectedTraitType: "PS",
        selectedFilterType: "PALM",

        isSnackbar: false,
        snackbarInfo: {
            isSnackbar: false,
            text: "Snackbar",
            color: "green darken-2"
        },

	    isDeleteAlert: false,
	    deleteAlert: {
	      isDeleteAlert: false,
	      id: null,
	      APIName: null,
	      tableName: null,
	      title: "Title Here",
	      description: "Description Here"
        },
		
        BreedingSelectionFilter: null,

        selectionRow: [],
        isUpdateAgrinomeTable: false,

        db: null,
		
        searchQuery: "",
    },
    actions: {

    },
    mutations: {
        callSnackBar (state, payload) {
		    state.isSnackbar = payload.isSnackbar;
            state.snackbarInfo = payload;
        },
        callDeleteAlert (state, payload) {
		  state.isDeleteAlert = payload.isDeleteAlert;
		  state.deleteAlert = payload;
        },
        editTableDialog (state, payload) {
            state.dialog = payload.isDialog;
            state.configurationInfo = payload;
        },
        addDialog (state, payload) {
            state.dialog = payload.isDialog;
            state.configurationInfo = payload;
        },
        storeSeriesForm(state, payload) {
            state.SeriesForms = payload;
        },
        storeBenchmarkForm(state, payload) {
            state.BenchmarkForm = payload;
        },
        storeTraitsForm(state, payload) {
            var filteredTraitForm;
            if (payload.length > 0) {
                filteredTraitForm = payload.filter(item => item.traitId != "");
            }
            else filteredTraitForm = payload;
            state.TraitsForm = filteredTraitForm;
        },
        updateTraitType(state, payload) {
            state.selectedTraitType = payload;
        },
        updateFilterType(state, payload) {
            state.selectedFilterType = payload;
        },
        storeMaterialSelectionFiltering(state, payload) {
            state.BreedingSelectionFilter = payload;
        },
        storeSelectionRow(state, payload) {
            state.selectionRow = payload;
        },
        updateAgrinomeTableState(state, payload) {
            state.isUpdateAgrinomeTable = payload;
        },
        storeSearchQuery(state, payload) {
            state.searchQuery = payload;
        }
    },
    getters
});


// WEBPACK FOOTER //
// ./src/vuex/store.js